import React, { useCallback, useEffect, useRef, useState } from "react";
import BasicTable from "../../../../Components/CommonTable/BasicTable/BasicTable.jsx";
import { useFetchAll } from "../../../../custom/FetchApiHook.jsx";
import {columns,searchBy,filters} from './Column.js'
import AddUserDetail from "./AddUserDetail.jsx";
import { UsersApi } from "../../../../App/api/users.api.js";
import { useSelector } from "react-redux";
import MenuApi from "../../../../App/api/menu.apis.js";
import { toast } from "react-toastify";

const UserList = ({meta, disabledFilters}) => {
  const [pagination,setPagination]=useState({
    "page": 1,
    "limit": 5,
    "sortOrder": "desc",
    "filter": {}
  })

  const handlePagination=(data)=>{
    // console.log(data);
    
    if (data.clearPagination) {
      setPagination(data.clearPagination)
      return
    }
    
    setPagination((prev)=>{
        let copyfilter={...prev.filter}
        // copyfilter[]
       
        if (data.filter) {
          // console.log("Object.keys[copyfilter]",Object.entries(copyfilter))
          // console.log("Object.keys[copyfilter]",Object.keys(data.filter))
          
          if (copyfilter[Object.keys(data.filter)[0]]) {
            copyfilter[Object.keys(data.filter)[0]]=Object.values(data.filter)[0]
            
          }else{

            copyfilter={...data?.filter,...copyfilter}
          }
        
        }
       
  
        return{
          page:data.page?data.page:prev.page,
          limit:data.limit?data.limit:prev.limit,
          sortOrder:data.sortOrder?data.sortOrder:prev.sortOrder,
          filter:copyfilter
        }
  
      })
    }
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);
  const { value, fetchAllData } = useFetchAll(() => UsersApi.getAllUsers(pagination,search)); 

 
  const [selectedCell, setSelectedCell] = useState(null);
  const [ModalOpen, setModalOpen] = useState(false);
  const [users, setUsers] = useState(null);

  const closeRoleModal = () => {
    setModalOpen(false);
    setUsers(null);
  };

  const handleRowClick = (row) => {
    setSelectedCell(row);
    setModalOpen(true);
  };

  const handleCellClick = async(cell, field = "") => {
    // console.log('Field',field);
    
    if (field === "profile_image") {
      setUsers(cell);
      setModalOpen(true);
    }
    if (
      field === "Approved" ||
      field === "Unapproved" ||
      field === "Blocked"
    ) {
      try {
        await UsersApi.approveUser( cell?._id,{status: field});
        fetchAllData();
      } catch (error) {
        toast.error(error.message);
      }
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback((s) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      handleSearch(s);
    }, 1500);
  }, [handleSearch]);

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {}
    };
    setSearch("")
    setPagination(clearPagination)    
  };

  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }
    handlePagination && handlePagination(data);
  };

  filters[1].options= useSelector((state)=>state.country.data.map((d)=>{return {name:d.name,code:d._id}}))
  // console.log('CountryData',filters);

  const getCity=async()=>{
    try {
      const res=await MenuApi.getAllCity(pagination.filter.country)
      // console.log('CityData',res);
      filters[2].options=res.data.data.map((d)=>{return {name:d.name,code:d._id}})
      
    } catch (error) {
      // console.log(error);
      
    }
    }

  useEffect(() => {
    fetchAllData();
    if (pagination.filter?.country) {
      getCity()
    }
  }, [pagination, search]);

 

  return (
    <div className="p-5">
      <BasicTable
        columns={columns}
        data={value?.data?.user || []}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: value?.data?.page || 1,
          rows: value?.data?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: value?.data?.totalPages || 1,
          totalCount: value?.data?.totalCount || 1
        }}
        onCellClick={(e) => console.log("Cell Data", e)}
        handleSearch={debouncedSearch}
        SearchBy={searchBy}
        filters={filters}
        handleFilter={handleFilter}
        handleClearFilter={handleClearFilter}
        selectedData={selectedCell}
        handleCellClick={handleCellClick}
        button_name="Add User"
        handleButton={() => {
          setModalOpen(true);
        }}
      />
      <AddUserDetail
        getAllData={fetchAllData}
        currentItems={users}
        open={ModalOpen}
        handleClose={closeRoleModal}
      />
    </div>
  );
};

export default UserList;
